export const OrgMsgCn = {
  name: '机构名称',
  principal: '负责人',
  mobile: '手机号',
  telephone: '座机号',
  department: '所在部门',
  position: '职务',
  orgCode: '机构标识',
  actID: '活动ID',
  create_at: '注册时间',
  operation: '操作',
  edit: '编辑',
  remove: '删除',
  search: '查询',
  searchPlaceHolder: '请输入机构名称，负责人',
  createOrg: '新建机构',
  editOrg: '编辑机构',
  selectHolder: '请选择',
  InputHolder: '请输入'
}
export const OrgModalMes = {
  name: `${OrgMsgCn.InputHolder}${OrgMsgCn.name}`,
  principal: `${OrgMsgCn.InputHolder}${OrgMsgCn.principal}`,
  mobile: `${OrgMsgCn.InputHolder}${OrgMsgCn.mobile}`,
  telephone: `${OrgMsgCn.InputHolder}${OrgMsgCn.telephone}。例如：02212345678`,
  department: `${OrgMsgCn.InputHolder}${OrgMsgCn.department}`,
  position: `${OrgMsgCn.InputHolder}${OrgMsgCn.position}`,
  orgCode: `${OrgMsgCn.selectHolder}${OrgMsgCn.orgCode}`,
  actID: `${OrgMsgCn.selectHolder}${OrgMsgCn.actID}`
}
